export default __webpack_public_path__ + "static/media/February2010.b8ec803b.png";